require('./bootstrap')

import {createApp} from 'vue'
import route from 'ziggy'
import translate from './translate'
import SubmitButton from './Components/Forms/SubmitButton'
import CopyToClipboard from './Components/Utilities/CopyToClipboard'
import * as Sentry from '@sentry/vue'

const app = createApp({
    components: {
        SubmitButton,
        CopyToClipboard,
    }
})

app.mixin(translate)

Sentry.init({
    app,
    dsn: "https://4eaed1d22e6648bf80e63ec311dbd079@o500851.ingest.us.sentry.io/5581250",
    integrations: [
        Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
});

app.mount('#base')
app.config.globalProperties.$route = route
